<template>
  <v-app class="app-container">
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: "App",
  components: {},
    mounted() {
      window.globalI18n = this.$i18n;
    },
    data() {
    return {};
  }
};
</script>

<style scoped lang="sass" src="./app.sass"></style>
